import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useEditor } from '../../hooks/useEditor';
import { Assets } from './Assets';
import { FlatStatesControlPanel } from './FlatStatesControlPanel';
import { Window } from './Window';
import { ElementTree } from './elementTree/ElementTree';
import { ToolbarButtons } from './toolbarButtons/ToolbarButtons';

export enum Pages {
  None,
  Elements,
  Assets,
  Window,
}

export const ToolbarContent = () => {
  const { setUI } = useEditor();
  const [currentPage, setCurrentPage] = useState(Pages.Elements);

  const setPage = (page: Pages) => {
    if (currentPage === page) setCurrentPage(Pages.None);
    else setCurrentPage(page);
  };

  useEffect(
    () =>
      setUI((UI) => ({
        ...UI,
        isToolbarExtended: currentPage === Pages.None ? false : true,
      })),
    [currentPage]
  );

  const renderContent = () => {
    switch (currentPage) {
      case Pages.Elements:
        return <ElementTree />;
      case Pages.Assets:
        return <Assets />;
      case Pages.Window:
        return <Window />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <ToolbarButtons
        {...{
          currentPage,
          setPage,
        }}
      />
      <ToolbarContentContainer id="toolbarContentContainer">
        <OuterContainer
          style={{
            height: 'calc(70% - 5px)',
            marginBottom: '5px',
          }}
        >
          <InnerContainer>{renderContent()}</InnerContainer>
        </OuterContainer>

        <OuterContainer
          style={{
            height: '30%',
          }}
        >
          <InnerContainer>
            <FlatStatesControlPanel />
          </InnerContainer>
        </OuterContainer>
      </ToolbarContentContainer>
    </>
  );
};

const OuterContainer = styled.div`
  box-sizing: border-box;
  height: 100%;
  background-color: var(--panel-bg-color-secondary);
  border-radius: 0 10px 10px 0;

  padding: 10px 0;
`;

const InnerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 10px;

  padding: 0 17px;

  overflow: auto;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background: linear-gradient(
    90deg,
    transparent,
    var(--input-border-color) 10%,
    var(--input-border-color) 90%,
    transparent
  );
`;

const ToolbarContentContainer = styled.div<{ $leftScrollbar?: boolean }>`
  user-select: none;
  box-sizing: border-box;
  width: 100%;
  min-width: 250px;

  border-radius: 0 10px 10px 0;

  font-size: 12px;
  font-weight: 300;

  overflow-y: auto;

  ${({ $leftScrollbar }) =>
    $leftScrollbar &&
    `
    direction: rtl;
  & > * {
    direction: ltr;
  }
    `}

  h1 {
    color: var(--text-color-secondary);
    font-size: 18px;
    font-weight: 300;
    text-align: center;
    padding: 10px 0;
  }
  h2 {
    color: var(--text-color-secondary);
    font-size: 16px;
    font-weight: 400;
    text-align: center;
  }
`;
